import React from 'react';
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


export default function HelpButton({ href, styles }) {
     return (
        <div style={{ float: 'right', ...styles }}>
            <Button target="blank" href={href} title="Clique aqui para obter ajuda" className="btn-icon-destaque btn-rounded" >
                <FontAwesomeIcon icon={["fas", "question"]} size={"lg"} />
            </Button>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/HelpButton.js